'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makePost = exports.makeGet = exports.makeDelete = exports.handleResponse = exports.addAuthToken = undefined;

var _config = require('../../../config');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var backupKey = _uuid2.default.v4();

var addAuthToken = exports.addAuthToken = function addAuthToken(request, authToken) {
    if (authToken) {
        request.set('Authorization', 'Bearer ' + authToken);
    }
};

var handleResponse = exports.handleResponse = function handleResponse(resolve, reject, err) {
    var response = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var transform = arguments[4];

    // If there is a server level error, reject the promise
    if (err) {
        return reject(err);
    }

    var body = response.body || {};
    if (transform) {
        body = transform(body);
    }

    // If the successa and message properties are set in body (item-api response)
    // but success is falsy, reject the promise
    if ('success' in body && 'message' in body && !body.success) {
        return reject(body.message);
    }

    // If the success property is set in body but is falsy, reject the promise
    // Might be some sort of lambda (Flynn)
    if ('success' in body && !body.success) {
        return reject(body);
    }

    // else
    return resolve(body);
};

var addCacheKey = function addCacheKey(request) {
    var c = _config.cachekey;
    if (!_config.cachekey) {
        c = backupKey;
    }
    request.query({ c: c });
    return request;
};

var hosts = [{
    path: '<ITEM-API>',
    url: 'https://item-api-DEPLOYMENT.liveauctioneers.com/'
}, {
    path: '<MAINHOST-API>',
    url: 'https://mainhost-api-DEPLOYMENT.liveauctioneers.com/'
}, {
    path: '<SAVED-SEARCH-API>',
    url: 'https://savedsearch-DEPLOYMENT.liveauctioneers.com/api/savedsearch/'
}, {
    path: '<SEARCH-API>',
    url: 'https://api.liveauctioneers.com/search/APIPATH/DEPLOYMENT'
}, {
    path: '<USER-API>',
    url: 'https://api.liveauctioneers.com/user/APIPATH/DEPLOYMENT'
}];

var buildUrl = function buildUrl(path, deployment, apiPath) {
    var updatedPath = '';
    hosts.forEach(function (obj) {
        if (path.includes(obj.path)) {
            var url = obj.url.replace('DEPLOYMENT', deployment);
            updatedPath = path.replace(obj.path, url);
            updatedPath = updatedPath.replace('APIPATH', apiPath);
        }
    });
    return updatedPath;
};

var makeDelete = exports.makeDelete = function makeDelete(path, deployment, apiPath) {
    var request = _superagent2.default.delete(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};

var makeGet = exports.makeGet = function makeGet(path, deployment, apiPath) {
    var request = _superagent2.default.get(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};
var makePost = exports.makePost = function makePost(path, deployment, apiPath) {
    var request = _superagent2.default.post(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/helpers.js
// module id = SY39
// module chunks = 46